import { Alert, Col, Row, Spin } from "antd";
import { BuscandoProveedor } from "./buscandoProveedor/BuscandoProveedor";
import { CapturandoDatos } from "./capturandoDatos/CapturandoDatos";
import { useSemaforoFase1 } from "../../../hooks/useAsistenciasSemaforo";

export const SemaforoFase1 = () => {
  const { asistencias, loading, error } = useSemaforoFase1();

  if (loading) return <Spin />;
  if (error) return <Alert type="error" message="No se pudo consultar el semáforo fase 1" />;

  return (
    <Row className="semaforo-general" gutter={[8, 8]}>
      <Col xs={24} md={12}>
        <CapturandoDatos asistenciasSemaforo={asistencias} />
      </Col>
      <Col xs={24} md={12}>
        <BuscandoProveedor asistenciasSemaforo={asistencias} />
      </Col>
    </Row>
  );
};
